import { IKnmNoticeType } from 'APIPackage/CatalogsModule/interfaces/IKnmNoticeType';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

export async function fetchKnmNoticeMethodsAll(): Promise<IKnmNoticeType[]> {
  return apiGet<IKnmNoticeType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-notice-methods/all`);
}

export async function createKnmNoticeMethod(knmNoticeMethod: Omit<IKnmNoticeType, 'id'>): Promise<void> {
  return apiPost<void>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-notice-methods`,
    body: knmNoticeMethod,
  });
}

export async function updateKnmNoticeMethod(knmNoticeMethod: IKnmNoticeType): Promise<void> {
  const { id, ...data } = knmNoticeMethod;

  return apiPut<void>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-notice-methods/${id}`, data);
}
